import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar"
import UserHandler from "js/utilities/user-handler";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import { ZOOM_ICON } from "js/config.jsx";

export default React.createClass({
  displayName: "Video Hub",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var scrollToElement = initDeepLinkData(this.props);
    return {
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container">

              <section id="Introduction">
                <div className="title">
                  <Glyphicon glyph="list" />
                <h2 id="video-tutorials">Video Tutorials</h2>
                </div>
                <p>Learn more about the FaceTec SDKs and watch walkthrough videos on setting up, integrating, and deploying the SDKs into your Apps.</p>
                <hr/>

              </section>

              <section>
                <h3 id="overviews">SDK Overviews</h3>
                <p>A couple high-level videos to introduce you to the FaceTec SDKs.</p>

                <div className="row">
                  <div className="col-sm-6"><h4>FaceTec Explainer Video (2019)</h4></div>
                  <div className="col-sm-6"><h4>FaceTec SDK - Browser, Server, Dashboard Demo</h4></div>
                </div>

                <div className="row">
                  <div className="col-sm-6"><p><iframe width="440" height="277" src="https://www.youtube.com/embed/uBrky5_g0-w" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></p></div>
                  <div className="col-sm-6"><p><iframe width="440" height="277" src="https://www.youtube.com/embed/hDGL3ie7UbY" frameBorder="0"   allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></p></div>
                </div>
              </section>

              <hr />

              <section>
                <h3 id="integrating-facetec-into-your-app-video-tutorials">Device SDK Integration Tutorial Videos</h3>
                <p>A collection of videos demonstrating initial setup and integration of the Device SDK.  Note: Some videos may not be on the very latest version of the SDKs and integration steps and code could vary slightly from the videos.</p>

                <div className="row">
                  <div className="col-sm-6"><h4>Android - Initial Integration</h4></div>
                  <div className="col-sm-6"><h4>iOS - Initial Integration</h4></div>
                </div>

                <div className="row">
                  <div className="col-sm-6"><p><iframe width="440" height="277" src="https://www.youtube.com/embed/ZsoZ55ydKgc" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></p></div>
                  <div className="col-sm-6"><p><iframe width="440" height="277" src="https://www.youtube.com/embed/d0rC7vgMSWw" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></p></div>
                </div>

                <div className="row">
                  <div className="col-sm-6"><h4>Browser - Initial Integration</h4></div>
                  <div className="col-sm-6"><h4>Browser (React) - Initial Integration</h4></div>
                </div>

                <div className="row">
                  <div className="col-sm-6"><p><iframe width="440" height="277" src="https://www.youtube.com/embed/xriU-CMTVIU" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></p></div>
                  <div className="col-sm-6"><p><iframe width="440" height="277" src="https://www.youtube.com/embed/JI3tWW87QNM" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></p></div>
                </div>

                <div className="row">
                  <div className="col-sm-6"><h4>Browser (Angular) - Initial Integration</h4></div>
                </div>

                <div className="row">
                  <div className="col-sm-6"><p><iframe width="440" height="277" src="https://www.youtube.com/embed/JI3tWW87QNM" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></p></div>
                </div>
              </section>

              <hr />

              <section>
                <h3 id="fss-fsd-video-tutorials">FaceTec Standard Server (FSS) and FaceTec Server Dashboard (FSD)</h3>
                <p>Integration and setup videos for <Link to="/standard-server-and-dashboard">FaceTec Standard Server and Server Dashboard</Link>.</p>
                <div className="row">
                  <div className="col-sm-6"><h4>Running Full FaceTec Stack on your Dev Machine<br />(Browser SDK + Standard Server + Dashboard) </h4></div>
                  <div className="col-sm-6"><h4>MongoDB Setup (Atlas) - Account + Credentials</h4></div>
                </div>
                <div className="row">
                  <div className="col-sm-6"><p><iframe width="440" height="277" src="https://www.youtube.com/embed/9z9AvfRarMw" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></p></div>
                  <div className="col-sm-6"><p><iframe width="440" height="277" src="https://www.youtube.com/embed/9x1EstLUmbw" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></p></div>
                </div>
              </section>

              <hr />

              <section>
                
                <h3 id="deploying-facetec-custom-server-video-tutorials">FaceTec Custom Server</h3>
                <p>Integration and setup videos for <Link to="/zoom-server-quickstart">FaceTec Custom Server</Link>.</p>

                <div className="row">
                  <div className="col-sm-6"><h4>FaceTec Custom Server Setup - Dev. Key</h4></div>
                  <div className="col-sm-6"><h4>FaceTec Custom Server Setup - Prod. Key</h4></div>
                </div>

                <div className="row">
                  <div className="col-sm-6"><p><iframe width="440" height="277" src="https://www.youtube.com/embed/BFBH8Obq7Ag" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></p></div>
                  <div className="col-sm-6"><p><iframe width="440" height="277" src="https://www.youtube.com/embed/JVrAfpUVZRQ" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></p></div>
                </div>

              </section>

              <hr />

              <section>
                <h3 id="facetec-windows-deploying-aws-video-tutorials">Misc. Deployment Tutorials</h3>
                <p>Videos demonstrating Browser SDK deployment and adding SSL.</p>
                <div className="row">
                  <div className="col-sm-6"><h4>Deploying Browser SDK + Angular (Windows IIS).</h4></div>
                  <div className="col-sm-6"><h4>AWS Deployments - Adding SSL to Your Endpoints By Using a Load Balancer and Route53</h4></div>
                </div>
                <div className="row">
                  <div className="col-sm-6"><p><iframe width="440" height="277" src="https://www.youtube.com/embed/VMIdHyl0cg4" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></p></div>
                  <div className="col-sm-6"><p><iframe width="440" height="277" src="https://www.youtube.com/embed/_uz-Rhv8jrM" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></p></div>
                </div>
              </section>

              <hr />

              <section>

                <h3 id="facetec-spoof-videos">FaceTec Spoof Videos</h3>
                <p>Watch how FaceTec SDKs rebuff spoofs and how deepfakes can easily be created that easily fool most of the competition in minutes.</p>

                <div className="row">
                  <div className="col-sm-6"><h4>Watch FaceTec vs. 120 Spoofs in 90 Seconds</h4></div>
                  <div className="col-sm-6"><h4>Creating a Deepfake Spoof</h4></div>
                </div>

                <div className="row">
                  <div className="col-sm-6"><p><iframe width="440" height="277" src="https://www.youtube.com/embed/MEPgs7ovb-g" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></p></div>
                  <div className="col-sm-6"><p><iframe width="440" height="277" src="https://www.youtube.com/embed/pAoTmlqMqjg" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></p></div>
                </div>

              </section>

              <hr />

              <SDKSidebar menuType="main" title="video-hub"/>

            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/video-tutorials.jsx